import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_row = _resolveComponent("v-row")
  const _component_v_col = _resolveComponent("v-col")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_checkbox, {
          modelValue: _ctx.caseCost,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.caseCost) = $event)),
          disabled: _ctx.caseCostDisabled,
          label: "Case cost occurs (€)",
          "hide-details": "",
          class: "shrink mr-2 my-2 px-3",
          style: {"min-width":"220px"}
        }, null, 8, ["modelValue", "disabled"]),
        (_ctx.caseCost)
          ? (_openBlock(), _createBlock(_component_v_text_field, {
              key: 0,
              modelValue: _ctx.caseCostValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.caseCostValue) = $event)),
              rules: _ctx.caseCostFieldValidationRules,
              placeholder: "Enter case cost. Please enter values without €",
              variant: "outlined",
              density: "compact",
              hint: "Amount in € that was spent by NSC or dealership as goodwill.",
              "persistent-hint": ""
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { align: "center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_checkbox, {
          modelValue: _ctx.discountGranted,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.discountGranted) = $event)),
          disabled: _ctx.discountGrantedDisabled,
          label: "Discount Granted (%)",
          "hide-details": "",
          class: "shrink mr-2 my-2 px-3",
          style: {"min-width":"220px"}
        }, null, 8, ["modelValue", "disabled"]),
        (_ctx.discountGranted)
          ? (_openBlock(), _createBlock(_component_v_text_field, {
              key: 0,
              modelValue: _ctx.discountGrantedValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.discountGrantedValue) = $event)),
              rules: _ctx.discountFieldValidationRules,
              placeholder: "Enter discount. Please enter values without %",
              variant: "outlined",
              density: "compact",
              "hide-details": ""
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.costRejection,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = $event => ((_ctx.localSolution.costRejection) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Cost rejection",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { align: "center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_checkbox, {
          modelValue: _ctx.detailedConsalting,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.detailedConsalting) = $event)),
          label: "Detailed consulting",
          "hide-details": "",
          class: "shrink mr-2 my-2 px-3",
          style: {"min-width":"220px"}
        }, null, 8, ["modelValue"]),
        (_ctx.detailedConsalting)
          ? (_openBlock(), _createBlock(_component_v_text_field, {
              key: 0,
              modelValue: _ctx.localSolution.detailedConsalting,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.localSolution.detailedConsalting) = $event)),
              rules: _ctx.textFieldValidationRules,
              placeholder: "Enter detailed consulting",
              variant: "outlined",
              density: "compact",
              "hide-details": ""
            }, null, 8, ["modelValue", "rules"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.forwardingToDealer,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = $event => ((_ctx.localSolution.forwardingToDealer) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Forwarding to dealer",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.repairCostCovered,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = $event => ((_ctx.localSolution.repairCostCovered) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Repair cost covered",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.partsCostCovered,
              "onUpdate:modelValue": [
                _cache[9] || (_cache[9] = $event => ((_ctx.localSolution.partsCostCovered) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Part cost covered",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.warrantyExt,
              "onUpdate:modelValue": [
                _cache[10] || (_cache[10] = $event => ((_ctx.localSolution.warrantyExt) = $event)),
                _ctx.solutionUpdated
              ],
              label: "BSI / Warranty ext.",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.connectedDriveUpdate,
              "onUpdate:modelValue": [
                _cache[11] || (_cache[11] = $event => ((_ctx.localSolution.connectedDriveUpdate) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Connected Drive Upgrade",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.loanerCar,
              "onUpdate:modelValue": [
                _cache[12] || (_cache[12] = $event => ((_ctx.localSolution.loanerCar) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Loaner / Courtesy car",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.vehicleCharging,
              "onUpdate:modelValue": [
                _cache[13] || (_cache[13] = $event => ((_ctx.localSolution.vehicleCharging) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Vehicle charging",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.vehicleTreatment,
              "onUpdate:modelValue": [
                _cache[14] || (_cache[14] = $event => ((_ctx.localSolution.vehicleTreatment) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Vehicle Treatment",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.experienceVoucher,
              "onUpdate:modelValue": [
                _cache[15] || (_cache[15] = $event => ((_ctx.localSolution.experienceVoucher) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Experience voucher / Event",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.lifestyleVoucher,
              "onUpdate:modelValue": [
                _cache[16] || (_cache[16] = $event => ((_ctx.localSolution.lifestyleVoucher) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Lifestyle voucher",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.discountOnNextCar,
              "onUpdate:modelValue": [
                _cache[17] || (_cache[17] = $event => ((_ctx.localSolution.discountOnNextCar) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Discount on next car",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.cashPayment,
              "onUpdate:modelValue": [
                _cache[18] || (_cache[18] = $event => ((_ctx.localSolution.cashPayment) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Cash payment / vehcile payment",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "4",
          class: "py-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              modelValue: _ctx.localSolution.buyBack,
              "onUpdate:modelValue": [
                _cache[19] || (_cache[19] = $event => ((_ctx.localSolution.buyBack) = $event)),
                _ctx.solutionUpdated
              ],
              label: "Buy back",
              "hide-details": "",
              class: "shrink mr-2 my-2"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}